const headerStatusAction = headerIsPinned => ({
    headerIsPinned,
    type: 'HEADER_IS_PINNED'
  }),
  isMobileAction = isMobile => ({
    isMobile,
    type: 'IS_MOBILE'
  });

export { headerStatusAction, isMobileAction };


// WEBPACK FOOTER //
// ./src/actions.js